// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const mini = gql`
  query mini($panelCollectionName: String!, $node: String!) {
    iconLink(panelCollectionName: $panelCollectionName, node: $node)
      @rest(
        type: "LiveDataPanelTableInstrument"
        path: "livedata/collections/{args.panelCollectionName}/miniIconLink?node={args.node}&template={args.panelCollectionName}"
      ) {
      iconLink
    }
    table(panelCollectionName: $panelCollectionName, node: $node)
      @rest(
        type: "LiveDataTable"
        path: "livedata/collections/{args.panelCollectionName}/miniTable?node={args.node}&template={args.panelCollectionName}"
      ) {
      title
      headerData @type(name: "LiveDataTableCell") {
        content
        title
        link
        image
        style
        ajaxUrl
        sortKey
        cells
        hasCells
        hasLink
        hasImage
      }
      rowData # TODO @type
      activeColumn
      size
      columns @type(name: "LiveDataTableColumn") {
        headerData @type(name: "LiveDataTableCell") {
          content
          title
          link
          image
          style
          ajaxUrl
          sortKey
          cells
          hasCells
          hasLink
          hasImage
        }
        number
      }
    }
  }
`;

export default mini;
